import React from "react";
import PropTypes from "prop-types";

import "./pageList.scss";

import PageListItem from "../PageListItem/pageListItem";

const PageList = ({
  pages = [],
  allPagesData = {},
  heading = "",
  showIcon = false,
}) => {
  if (pages.length === 0) {
    return <></>;
  }

  return (
    <div className="page-list-div">
      {heading && <div className="page-list-heading">{heading}</div>}
      <div className="page-list">
        {pages?.map(uri => {
          return (
            <PageListItem
              key={uri}
              uri={uri}
              allPagesData={allPagesData}
              showIcon={showIcon}
            />
          );
        })}
      </div>
    </div>
  );
};

PageList.propTypes = {
  pages: PropTypes.array,
  allPagesData: PropTypes.object,
  heading: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default PageList;
